<template>
    <svg class="text-primary" xmlns="http://www.w3.org/2000/svg" width="4.855" height="8" viewBox="0 0 4.855 8">
        <path class="fill-current" id="Caminho_10434" data-name="Caminho 10434" d="M32.221,41.968l-3.56,3.56a.44.44,0,0,1-.622,0l-.415-.415a.44.44,0,0,1,0-.621l2.822-2.835-2.822-2.835a.44.44,0,0,1,0-.621l.415-.415a.44.44,0,0,1,.622,0l3.56,3.56A.44.44,0,0,1,32.221,41.968Z" transform="translate(-27.494 -37.657)"/>
    </svg>
</template>
